<template>
  <v-dialog v-model="visible">
    <box :title="this.$t('message')">
      <div class="d-flex flex-column pa-2">
        <div class="d-flex">
          <strong>عنوان : </strong>
          <span class="px-1">{{ message.Subject }}</span>
        </div>
        <div class="d-flex mt-2">
          <strong>فرستنده : </strong>
          <span class="px-1">{{ message.Sender }}</span>
        </div>
        <div class="d-flex mt-2">
          <strong>متن پیام : </strong>
          <pre class="px-1">{{ message.Message }}</pre>
        </div>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <small class="text-muted">{{ message.SentDate }}</small>
        </div>
      </div>
    </box>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      message: {},
    };
  },
  mounted() {},
  methods: {
    show(message) {
      this.visible = true;
      this.message = message;
    },
  },
};
</script>

<style>
</style>